import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { recover } from 'src/store/actions/user'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import Loading from 'src/components/Loading/Loading'

import './Recover.sass'

const Recover = () => {
  const dispatch = useDispatch()
  const [status, setStatus] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (status === 'loading') return
    const email = e.target.email.value
    setStatus('loading')
    dispatch(recover(email))
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'))
  }

  let messageClass = 'message'
  if (status === 'success') {
    messageClass += ' success'
  } else {
    messageClass += ' error'
  }

  const recoverForm = (
    <form onSubmit={handleSubmit} className={status}>
      <label>
        <span className="icon icon-mail" />
        <FormattedMessage id="placeholder.email">
          {(text: string) => (
            <input
              type="email"
              name="email"
              placeholder={text}
              autoComplete="email"
              required
            />
          )}
        </FormattedMessage>
      </label>
      <p className={messageClass}>
        {status === 'error' && (
          <span>
            <FormattedMessage id="recover.error" />
          </span>
        )}
        {status === 'success' && (
          <span>
            <FormattedMessage id="recover.success" />
          </span>
        )}
      </p>
      <button className="filled" type="submit">
        <FormattedMessage id="recover.send" />
      </button>
    </form>
  )

  return (
    <div id="recover" className="page split">
      <header className="item left" id="recover-header" />
      <section className="item right" id="recover-content">
        <div className="wrapper">
          <img src="images/logo.png" alt="logo" />
          <Link to="/">
            <span className="icon icon-arrow-left" />
            <FormattedMessage id="recover.back" />
          </Link>
          <div className="recover-form">
            <h2>
              <FormattedMessage id="recover.title" />
            </h2>
            <p>
              <FormattedMessage id="recover.description" />
            </p>
            {status !== 'loading' ? recoverForm : <Loading />}
          </div>
          <h4>
            <FormattedMessage id="recover.cant-remember" />
            <Link to="/" className="button filled_secondary">
              <FormattedMessage id="recover.contact" />
            </Link>
          </h4>
        </div>
      </section>
    </div>
  )
}

export default Recover
